"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchInput = exports.searchInputContext = exports.SearchInputProvider = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _useDebounce = require("use-debounce");
var _useGetSearchPreviewData = require("../../hooks/useGetSearchPreviewData");
var _configurationContext = require("../configurationContext");
var _jsxRuntime = require("react/jsx-runtime");
const searchInputContext = exports.searchInputContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const {
  Provider
} = searchInputContext;
const SearchInputProvider = ({
  children
}) => {
  const {
    showSearchOnScroll
  } = (0, _configurationContext.useAppConfig)();
  const [value, setValue] = (0, _react.useState)('');
  const {
    open: isFocused,
    onClose: blur,
    onOpen: focus
  } = (0, _presentationHooks.useDisclose)();
  const {
    open: isVisible,
    onClose: hide,
    onOpen: show
  } = (0, _presentationHooks.useDisclose)({
    defaultOpen: Boolean(showSearchOnScroll)
  });
  const {
    open: isManuallyOpened,
    onClose: manualHide,
    onOpen: manualShow
  } = (0, _presentationHooks.useDisclose)();
  const [debouncedValue] = (0, _useDebounce.useDebounce)(value, 750);
  const {
    isLoading,
    data: results,
    timestamp,
    clearResults
  } = (0, _useGetSearchPreviewData.useGetSearchPreviewData)({
    query: debouncedValue
  });
  const context = (0, _react.useMemo)(() => ({
    blur,
    clearResults,
    focus,
    hide,
    isFocused,
    isManuallyOpened,
    isVisible,
    manualHide,
    manualShow,
    results,
    setValue,
    show,
    timestamp,
    value,
    isLoading,
    debouncedValue
  }), [blur, clearResults, focus, hide, isFocused, isManuallyOpened, isVisible, manualHide, manualShow, results, show, timestamp, value, isLoading, debouncedValue]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: context,
    children: children
  });
};
exports.SearchInputProvider = SearchInputProvider;
const useSearchInput = () => {
  const context = (0, _react.useContext)(searchInputContext);
  if (context) {
    return context;
  }
  throw new Error('useSearchInput must be used within a SearchInputProvider.');
};
exports.useSearchInput = useSearchInput;
//# sourceMappingURL=searchInputContext.js.map